<template>
  <div>
    <van-popup
      v-model="isShow"
      class="sub-popup"
      :class="{'popup_qrcode':qrcode,'popup_pc':commonStore.isForPC}"
      get-container="body"
      :close-on-click-overlay="false"
    >
    <!-- app -->
      <div class="pop_wrap" v-if="!qrcode">
        <img
          class="icon_close"
          src="@/assets/img/activity/icon_close.png"
          alt=""
          @click="closePop()"
        />
        <div class="tip">填写常用地址后</div>
        <div class="tip">才能推荐附近的好职位</div>
        <div class="sub_btn" @click="openLocation()">去填写</div>
      </div>
      <!-- pc -->
      <div class="pop_wrap" v-else-if="commonStore.isForPC">
        <img
          class="icon_close"
          src="@/assets/img/activity/icon_close.png"
          alt=""
          @click="closePop()"
        />
        <img v-if="platform.includes('yjs')" class="qr_img" src="./images/yjs.png" alt="">
        <img v-else class="qr_img" src="./images/job.png" alt="">
        <div class="tip">手机扫码打开前程无忧App，填写常</div>
        <div class="tip">用地址后才能推荐附近的好职位</div>
        <div class="sub_btn" @click="refreshPage()">已填写，去刷新</div>
      </div>
      <!-- 小程序、h5、 -->
      <div class="pop_wrap" v-else>
        <img
          class="icon_close"
          src="@/assets/img/activity/icon_close.png"
          alt=""
          @click="closePop()"
        />
        <img v-if="platform.includes('yjs')" class="qr_img" src="./images/yjs.png" alt="">
        <img v-else class="qr_img" src="./images/job.png" alt="">
        <div class="tip">长按二维码保存，微信扫码打开前</div>
        <div class="tip">程无忧App，填写常用地址后才能</div>
        <div class="tip">推荐附近的好职位</div>
        <div class="sub_btn" @click="refreshPage()">已填写，去刷新</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import wx from "weixin-js-sdk";
import { Popup } from "vant";
export default {
  name: "NearbyPop",
  components: {
    [Popup.name]: Popup,
  },
  props: {
    intentionPopVisible: {
      type: Boolean,
      default: false,
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(["commonStore"]),
    isShow: {
      get() {
        return this.commonStore.nearbyPopShow;
      },
      set() {},
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    qrcode(){
      return !this.isApp&&!this.isMobile
      // return true
    },
    isApp() {
      return ["51jobApp", "yjsApp"].includes(this.platform)
    },
    isMobile() {
      return ["51jobM", "yjsM"].includes(this.platform)
    },
    isWeChat() {
      return this.$store.getters.appType === "weixin";
    },
    platform() {
      return this.$store.getters.platform;
    },
    isMiniProgram() {
      return (
        this.$store.getters.platform === "51jobWX" ||
        this.$store.getters.platform === "yjsWX"
      );
    },
  },
  data() {
    return {};
  },
  mounted() {
    
  },
  methods: {
    refreshPage(){
      if(!this.isLogin){
        this.$base.toLogin();
      }else{
        location.reload()
      }
    },
    openLocation() {
      if(!this.isLogin){
        this.$base.toLogin();
        return
      }
      let yjs = this.platform.includes("yjs")
      let job51 = this.platform.includes("51job")
      console.log(this.commonStore,'intention');
      if(this.isApp){
        let url
        if (yjs) {
          this.$base.watchAppCover(this.refreshPage);
          const intentions = this.commonStore.intention;
          if (intentions) {
            url = `yingjiesheng://home/openUsualAddress?area=${intentions.expectArea}&areaString=${intentions.expectAreaString}`;
          } else {
            url = `yingjiesheng://home/openUsualAddress`;
          }
        } else if (job51) {
          this.$base.watchAppCover(this.refreshPage);
          url = "qiancheng://home/show_job_location_page";
        }
        window.location.href = url
      }else{
        if (yjs) {
          window.location.href = "https://q.yingjiesheng.com/download?deeplink=yingjiesheng%3A%2F%2Fhome%2FopenUsualAddress";
        } else if (job51) {
          window.location.href = "https://app.51job.com/?deeplink=qiancheng%3A%2F%2Fhome%2Fshow_job_location_page";
        }
      }
    },
    closePop() {
      console.log(this.pageConfig,'prevLink');
      this.$base.goBack(this.pageConfig?.prevLink);
    },
  },
};
</script>

<style lang="less" scoped>
.sub-popup::before {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  content: "";
  height: 181px;
  width: 311px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("@/assets/img/activity/tipPopBg.png");
}

.sub-popup {
  position: fixed;
  overflow-y: visible;
  width: 311px;
  background: linear-gradient(180deg, #fffce1 0%, #ffffff 50%);
  border-radius: 16px;
  text-align: center;
  font-style: normal;
  opacity: 1;
  background: #ffffff;
  .icon_close {
    position: absolute;
    top: 10px;
    left: 16px;
    width: 18px;
    height: 18px;
  }
  .qr_img{
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 92px;
    height: 92px;
  }
  .pop_wrap {
    position: relative;
    z-index: 2;
    padding-top: 131px;
  }
  .tip {
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    color: #000000;
  }
  .follow_tip {
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    color: #666666;
    margin: 6px 0 24px;
  }
  .sub_btn {
    width: 200px;
    height: 44px;
    line-height: 44px;
    margin: 24px auto 32px;
    border-radius: 22px;
    opacity: 1;
    background: linear-gradient(180deg, #ffb240 2%, #ff6300 100%);
    box-sizing: border-box;
    border: 1px solid #ffe7ce;
    box-shadow: inset 0px 3px 9px 0px #ff6906;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
  }
}
.van-popup{
  .pc & {
    top: 50% !important;
    width: 311px !important;
    transform: translate(-50%,-50%) !important;
  }
}
.popup_qrcode::before {
  background-image: url("./images/nearby_bg.png");
  .pop_wrap{
    padding-top: 139px;
  }
}
.popup_qrcode {
  .pop_wrap{
    padding-top: 139px;
  }
  .tip {
    font-size: 16px;
  }
  .sub_btn {
    margin: 20px auto 30px;
  }
}
.popup_pc::before {
  background-image: url("./images/nearby_bg_pc.png");
  width: 435px;
  height: 253px;
  .pop_wrap{
    padding-top: 139px;
  }
}
.popup_pc {
  border-radius: 22px;
  .tip {
    font-size: 22px;
  }
  .icon_close{
    top: 14px;
    left: 22px;
    width: 26px;
    height: 26px;
  }
  .pop_wrap{
    padding-top: 196px;
  }
  .pc & {
    width: 435px !important;
    transform: translate(-50%,-50%) !important;
  }
  .qr_img{
    position: absolute;
    top: 46px;
    left: 50%;
    transform: translateX(-50%);
    width: 126px;
    height: 126px;
  }
  .sub_btn {
    margin: 29px auto 44px;
    border-radius: 30.8px;
    height: 62px;
    width: 280px;
    line-height: 62px;
    font-size: 22px;
    font-weight: 600;
  }
}
</style>
